function inRange(x, min, max) {
  return ((x-min)*(x-max) <= 0);
}

function checkVisible(elm) {
  var rect = elm.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

function checkMatchedTwoArrays(arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(v => arr2.includes(v));
}

function isFloat(n) {
  return n === +n && n !== (n|0);
}

function isInteger(n) {
  return n === +n && n === (n|0);
}
